import React from "react";
import { Box } from "@mui/material";
import { useWindowSize } from "@uidotdev/usehooks";

// Template143: Consejos útiles para Seúl
// Contenido desde page (texts, canvasImages, data.tips). Sin fallbacks.
const Template143 = ({
	backgroundColor,
	textColor,
	headerBackgroundColor,
	headerTextColor,
	fontFamily,
	page,
	updatePage,
}) => {
	const size = useWindowSize();
	const isSmallScreen = size.width <= 600;

	const headerText = page?.texts?.[0]?.content;

	const getCanvasImageUrl = (id) => {
		if (page?.canvasImages && Array.isArray(page.canvasImages)) {
			const found = page.canvasImages.find((img) => img?.id === id);
			if (found && found.imageUrl) return found.imageUrl;
		}
		return undefined;
	};

	const wifiSticker = getCanvasImageUrl("wifi-sticker");
	const papagoSticker = getCanvasImageUrl("papago-sticker");
	const logoImage = getCanvasImageUrl("logo");

	const intro = page?.texts?.[1]?.content;
	const tips =
		Array.isArray(page?.data?.tips)
			? page.data.tips
			: Array.isArray(page?.data?.data?.tips)
			? page.data.data.tips
			: [];

	let actualHeaderColor = headerBackgroundColor || "#2E8B80";
	const contentColor = textColor || "#444";

	const p = {
		fontFamily: `${fontFamily || "'Poppins', sans-serif"} !important`,
		fontSize: 13,
		color: contentColor,
		margin: 0,
	};

	return (
		<Box
			sx={{
				display: "flex",
				flexDirection: "column",
				minHeight: "100%",
				height: "auto",
				width: "100%",
				backgroundColor: backgroundColor || "#f7f7f7",
				color: contentColor,
				fontFamily: `${fontFamily || "'Poppins', sans-serif"} !important`,
				"& *:not([data-template-header])": {
					fontFamily: `${fontFamily || "'Poppins', sans-serif"} !important`,
					color: "inherit",
				},
			}}
		>
			{headerText && (
				<Box
					data-block-id="header"
					data-template-header
					sx={{
						backgroundColor: actualHeaderColor,
						color: headerTextColor || "#fff",
						textAlign: "center",
						padding: "15px 0",
						fontSize: "14px",
						fontWeight: 800,
						flexShrink: 0,
						position: "sticky",
						top: 0,
						zIndex: 99999,
					}}
				>
					{headerText}
					{logoImage && !isSmallScreen && (
						<Box
							component="img"
							src={logoImage}
							alt="logo"
							sx={{
								width: 80,
								position: "absolute",
								right: 2,
								top: 18,
								zIndex: 999999,
							}}
						/>
					)}
				</Box>
			)}

			{intro && (
				<Box data-block-id="text-1" sx={{ padding: "16px", fontSize: 13, color: contentColor }}>
					<Box component="p" sx={p}>
						{intro}
					</Box>
				</Box>
			)}

			<Box
				data-block-id="text-2"
				sx={{
					padding: "0 16px 20px",
					display: "flex",
					flexDirection: "column",
					gap: "12px",
					position: "relative",
					marginTop: isSmallScreen ? "0px" : 0,
				}}
			>
				{isSmallScreen && wifiSticker && (
					<img
						src={wifiSticker}
						alt="tips"
						style={{
							width: 90,
							position: "absolute",
							top: 40,
							right: -20,
						}}
					/>
				)}
				{tips.map((tip, index) => (
					<Box
						key={index}
						sx={{
							backgroundColor: "#fff",
							borderRadius: "12px",
							padding: "12px 14px",
							display: "flex",
							alignItems: "center",
							gap: "10px",
							border: "2px solid #d9e6de",
						}}
					>
						{tip.icono && <Box sx={{ fontSize: 18 }}>{tip.icono}</Box>}
						{tip.content && (
							<Box sx={{ fontSize: 13, color: contentColor }}>{tip.content}</Box>
						)}
					</Box>
				))}

				{!isSmallScreen && wifiSticker && (
					<img
						src={wifiSticker}
						alt="tips"
						style={{
							width: 90,
							position: "absolute",
							top: 40,
							right: -9,
						}}
					/>
				)}
				{papagoSticker && (
					<img
						src={papagoSticker}
						alt="tips"
						style={{
							width: 100,
							position: "absolute",
							bottom: isSmallScreen ? -65 : -65,
							left: 0,
						}}
					/>
				)}
			</Box>
		</Box>
	);
};

Template143.thumbnail = "/images/template-1.png";

export default Template143;
